export default {
    parts: ['root'],
    baseStyle: {
        root: {
            position: 'relative',
            rounded: 'none'
        }
    },
    variants: {
        default: {
            root: {
                p: 4,
                maxW: '458px',
                border: '1px solid',
                borderColor: 'webTheme.strokeTertiary',
                bg: 'transparent',
                boxShadow: 'none'
            }
        }
    },
    defaultProps: {
        variant: 'default'
    }
}
